export function safeJSONParse<T>(value: string | null): T | null {
  try {
    return value ? (JSON.parse(value) as T) : null;
  } catch (error) {
    console.error('safeJSONParse error (returning null):', error);
    return null;
  }
}
